import useAgreement from "../../Global/Api/Settings/agreement.api";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";


import './index.scss'

export default function ServiceAgreement() {
  const navigate = useNavigate();
  const { agreement, get } = useAgreement();
  const businessId = localStorage.getItem("businessId");


  useEffect(() => {
    get(businessId);
  }, []);


  return (
    <div className='agreement container'>
      <h3 className="agreement__title">
        {agreement?.title}</h3>
      <div className="agreement__text" dangerouslySetInnerHTML={{ __html: agreement?.body }} />
    </div>
  )
}

